(function () {
  function initMap(el) {
    if (el.dataset.catalogueMapBooted === '1') return;
    el.dataset.catalogueMapBooted = '1';

    function loadMap(styles) {
      var center = {
        lat: parseFloat(el.dataset.lat),
        lng: parseFloat(el.dataset.lng)
      };
      var map = new google.maps.Map(el, {
        center: center,
        zoom: parseInt(el.dataset.zoom, 10),
        styles: styles,
        disableDefaultUI: false,
        zoomControl: true,
        streetViewControl: false,
        mapTypeControl: false,
        fullscreenControl: false,
        clickableIcons: false,
        gestureHandling: 'cooperative',
        backgroundColor: '#F4EEE0'
      });

      var fill = el.dataset.markerColor || '#E0241C';
      var stroke = el.dataset.markerStroke || '#14110F';
      var svg =
        '<svg xmlns="http://www.w3.org/2000/svg" width="44" height="56" viewBox="0 0 44 56">' +
          '<path d="M22 2 C10 2 2 11 2 22 c0 14 20 32 20 32 s20 -18 20 -32 C42 11 34 2 22 2 z" ' +
            'fill="' + fill + '" stroke="' + stroke + '" stroke-width="2.5" stroke-linejoin="round"/>' +
          '<circle cx="22" cy="22" r="6" fill="' + stroke + '"/>' +
        '</svg>';

      new google.maps.Marker({
        position: center,
        map: map,
        title: el.dataset.placeLabel || '',
        icon: {
          url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg),
          scaledSize: new google.maps.Size(44, 56),
          anchor: new google.maps.Point(22, 54)
        }
      });
    }

    if (!el.dataset.styleUrl) {
      loadMap([]);
      return;
    }
    fetch(el.dataset.styleUrl)
      .then(function (r) { return r.json(); })
      .catch(function () { return []; })
      .then(loadMap);
  }

  function bootAll() {
    var maps = document.querySelectorAll('[data-map][data-api-key]');
    if (!maps.length) return;

    if (window.google && window.google.maps) {
      maps.forEach(initMap);
      return;
    }

    if (document.getElementById('catalogue-maps-loader')) {
      var attempts = 0;
      var poll = setInterval(function () {
        attempts++;
        if (window.google && window.google.maps) {
          clearInterval(poll);
          maps.forEach(initMap);
        } else if (attempts > 100) {
          clearInterval(poll);
        }
      }, 100);
      return;
    }

    var key = maps[0].dataset.apiKey;
    window.__catalogueMapsInit = function () {
      document.querySelectorAll('[data-map][data-api-key]').forEach(initMap);
    };
    var s = document.createElement('script');
    s.id = 'catalogue-maps-loader';
    s.src = 'https://maps.googleapis.com/maps/api/js?key=' + encodeURIComponent(key) +
      '&callback=__catalogueMapsInit&loading=async';
    s.async = true;
    s.defer = true;
    document.head.appendChild(s);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }

  // Re-init when Shopify rerenders a section in the theme editor.
  document.addEventListener('shopify:section:load', bootAll);
})();
